import { createSelector } from 'reselect'
import { find } from 'lodash'

const getRadarSettingsGroups = (state) => state.radarSettings && state.radarSettings.groups
const getStoredPhen = (state) => state?.radarSettings?.storedPhenomenon
const getPublicSharedLinkEnabled = (state) => state?.radarSettings?.enable_public_share_url || state?.radarSettings?.publicShareUrlEnabled

export const isCollaborationToolsAllowed = createSelector([ getRadarSettingsGroups ], (groups) => {
    return (groupId) => {
        const group = find(groups, g => groupId === g.id)
        if (group) {
            if (group.availableResources.hasOwnProperty('collaborationTools')) {
                return !!group.availableResources.collaborationTools
            }
            // Allowed for legacy accounts
            return true
        }
        return false
    }
})

export const storedPhenSelector = createSelector(getStoredPhen, storedPhenomenon => {
    return storedPhenomenon ?? []
})

export const isPublicSharedLinkEnabled = createSelector(getPublicSharedLinkEnabled, isSharedLinkEnabled => {
    return isSharedLinkEnabled
})
